module.exports = __webpack_public_path__ + "static/media/boxtime.490a38b7.svg";